import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

interface RedirectAvatarProps {
  title: string;
}

function RedirectToAvatar(props: RedirectAvatarProps) {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    document.title = props.title;
  }, [props.title]);

  const idParam = searchParams.get('id');
  
  if (idParam) {
    return <Navigate to={`/avatar?id=${idParam}`} replace />;
  }

  return <Navigate to="/not-found" replace />;
}

export default RedirectToAvatar;
